import { api } from '../../services';

/**
 * Signs the user out and redirects to the home page on success.
 * Receives setFullPageLoader to control the global loading state.
 */
export const signOut = async (setFullPageLoader) => {
    try {
        setFullPageLoader(true);

        const response = await api.get('/v1/login/logout');

        if (response.status === 200) {
            window.location.replace('/');
        }
    } catch (err) {
        console.error('Error while signing user out:', err);
    } finally {
        setFullPageLoader(false);
    }
};
